<template>
  <router-view />
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  overflow-x: hidden;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100vh;
  height: 100dvh;
}

/* 顶栏避让：手机浏览器用安全区；App WebView 由原生壳已避开状态栏 */
:root {
  --safe-top: env(safe-area-inset-top, 0px);
  --app-top-extra: 0px;
  --layout-top-pad: 0px;
  --brand: #1e3a5f;
  --brand-soft: #e8eef6;
  --accent: #d97706;
  --page-bg: #eef1f5;
}
html.has-safe-top:not(.in-app) {
  --layout-top-pad: calc(var(--safe-top) + var(--app-top-extra));
}
html.in-app {
  /* 全屏 WebView：默认 52px 避开摄像头；壳层会再写入精确状态栏高度 */
  --layout-top-pad: 52px;
  --el-color-primary: #1e3a5f;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* ===== 手机适配 ===== */
@media (max-width: 768px) {
  .header {
    flex-wrap: wrap;
    gap: 8px !important;
  }

  .header > div {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .search-form.el-form--inline .el-form-item {
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .search-form .el-input,
  .search-form .el-select,
  .search-form .el-date-editor {
    width: 100% !important;
  }

  .el-table {
    width: 100%;
    font-size: 12px;
  }

  /* 勾选列收窄，避免挤占内容 */
  .el-table .el-table-column--selection .cell {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  .el-table .el-table__cell.el-table-column--selection {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .el-table .el-checkbox {
    height: 18px;
    width: 18px;
  }
  .el-table .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }

  /* 右侧固定操作列：收紧内边距，减轻遮挡 */
  .el-table .el-table__fixed-right .cell,
  .el-table .el-table__fixed-right-patch {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .el-table .el-table__fixed-right {
    box-shadow: -6px 0 10px rgba(0, 0, 0, 0.06);
  }
  .el-table .el-table__body .el-table__cell {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .el-table .el-button--small {
    padding: 4px 6px;
    font-size: 12px;
  }
  .el-table .el-button + .el-button {
    margin-left: 4px;
  }
  .el-table .el-tag {
    max-width: 100%;
    height: auto;
    white-space: normal;
    line-height: 1.2;
    padding: 2px 5px;
  }

  /* 通用两字操作按钮（订单/客户等） */
  .row-actions {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  .op-btn {
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #409eff;
    font-size: 13px;
    line-height: 1.2;
    cursor: pointer;
    width: 2em;
    text-align: center;
  }
  .op-btn.op-danger,
  .op-danger {
    color: #f56c6c;
  }

  .el-card {
    --el-card-padding: 12px;
  }

  .el-dialog {
    width: 94% !important;
    max-width: 94vw !important;
    margin-top: 8vh !important;
  }

  .el-dialog__body {
    padding: 12px 14px;
    max-height: 70vh;
    overflow-y: auto;
  }

  .el-pagination {
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .el-pagination .el-pagination__sizes,
  .el-pagination .el-pagination__jump {
    display: none !important;
  }

  .el-form-item__label {
    padding-bottom: 4px;
  }

  .el-message-box {
    width: 90% !important;
  }
}
</style>
